<template>
    <div>
        <a-row type="flex" justify="end" style="margin-bottom: 12px">
            <a-col :span="24" style="padding-left: 12px">
                <strong style="font-size: 25px">Peserta</strong>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-form layout="inline" :form="form" @submit="handleSubmit">
                <a-row
                    :gutter="24"
                    class="form-filter-wrapper"
                    :class="'expanded'">
                    <a-col :span="6">
                        Peserta:
                        <a-input placeholder="Nama peserta" v-model="filters.q">
                            <a-icon
                                slot="prefix"
                                type="search"
                                style="color: rgba(0, 0, 0, 0.25)"
                            />
                        </a-input>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="end">
                    <a-col>
                        <a-button
                            type="primary"
                            html-type="submit"
                            icon="filter"
                            >Filter
                        </a-button>
                        <a-button
                            type="dashed"
                            html-type="reset"
                            icon="reload"
                            @click="handleReset"
                            >Reset
                        </a-button>
                    </a-col>
                </a-row>
            </a-form>

            <a-divider dashed />

            <a-card type="inner" size="small">
                <a-skeleton :loading="loading" active>
                    <a-table
                        :columns="columns"
                        :dataSource="data.data"
                        rowKey="hash"
                        :pagination="{
                            current: data.current_page,
                            total: data.total,
                            defaultPageSize: data.per_page
                        }"
                        @change="tableChanged"
                    >
                        <div slot="name" slot-scope="record">
                            {{ record.name }}
                        </div>

                        <div slot="branch" slot-scope="record">

                        </div>

                        <div slot="position" slot-scope="record">
                            {{ record.position }}
                        </div>

                        <div slot="class" slot-scope="record">
                        </div>

                        <div slot="gender" slot-scope="record">
                            <center>
                                {{ record.gender == 'female' ? 'P' : 'L' }}
                            </center>
                        </div>

                        <div slot="is_active" slot-scope="record">
                            <a-tag :color="record.is_active == true ? 'green' : 'red'">
                                {{ record.is_active == true ? "active" : "not active" }}
                            </a-tag>
                        </div>

                        <div slot="action" slot-scope="record" class="text-center">
                            <a-tooltip title="Edit Peserta">
                                <a-button
                                    size="small"
                                    type="primary"
                                    icon="edit"
                                />
                            </a-tooltip>
                        </div>
                    </a-table>
                </a-skeleton>
            </a-card>
        </a-card>
    </div>
</template>

<script>
const columns = [
    {
		key: 'name',
		title: 'Nama Lengkap',
		scopedSlots: {customRender: 'name'},
	}, {
		key: 'branch',
		title: 'Cabang',
		scopedSlots: {customRender: 'branch'}
	}, {
		key: 'position',
		title: 'Posisi',
		scopedSlots: {customRender: 'position'}
	}, {
		key: 'class',
		title: 'Kelas',
		scopedSlots: {customRender: 'class'}
	}, {
		key: 'gender',
		title: 'Gender',
		scopedSlots: {customRender: 'gender'}
	}, {
		key: 'is_active',
		title: 'Status',
		scopedSlots: {customRender: 'is_active'}
	}, {
		key: 'action',
		title: 'Action',
		scopedSlots: {customRender: 'action'}
	}
]

export default {
    data() {
        return {
            columns,
            form: this.$form.createForm(this),
            loading: false,
            expand: false,
            data: [],
            filters: {
                q: null,
                page: 1,
                paginate: true
            },
        }
    },
    created() {
        this.data = this.getDefaultPagination()
        this.filters = _.merge(this.filters, this.$laravel.request)
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.training-members'), {params: this.filters})
                .then((response) => (this.data = response.data.members))
                .catch((error) => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        handleSubmit(e) {
            e.preventDefault()
            this.pushState(this.filters)
            this.getItems()
        },
        handleReset(e) {
            e.preventDefault()

            this.filters = {
                q: null,
                page: 1,
            }
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current
            this.pushState(this.filters)
            this.getItems()
        },
    },
}
</script>
